import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostCheckLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CHECK_PRIZE_LOTTERY
            });
            if (data.status === 'success') {
                dispatch(Action.SetPostIssueLottery(params));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCheckLottery as SetPostCheckLottery
}